export default __webpack_public_path__ + "static/media/ClearText.ba719e2a.svg";